import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { POISearchResult } from '@alltrails/types/AlgoliaResults';

export type ExplorePOIState = {
  poi?: POISearchResult;
};

export const initialState: ExplorePOIState = {
  poi: undefined
};

export const poiSlice = createSlice({
  name: 'explorePOI',
  initialState,
  reducers: {
    resetState: (state, action: PayloadAction<{ persistKeys?: (keyof ExplorePOIState)[]; initialState?: Partial<ExplorePOIState> }>) => {
      const defaultState: ExplorePOIState = { ...initialState, ...(action.payload.initialState || {}) };
      action.payload.persistKeys?.forEach(key => {
        const persistValue = state[key];
        (defaultState[key] as typeof persistValue) = persistValue;
      });

      return defaultState;
    },
    setPoi: (state, action: PayloadAction<POISearchResult>) => {
      state.poi = action.payload;
    }
  }
});

export const { resetState, setPoi } = poiSlice.actions;
export default poiSlice.reducer;
